import { BaseViewStore } from 'core/stores';
import { ChannelStore } from 'modules/channel/stores';
import { ApplicationStore } from 'platform/application/stores';
import { WarehouseCodesForm } from 'modules/order/forms';
import { action, makeObservable } from 'mobx';
import { sourceOfChange, viewStoreName } from 'common/constants';
import _ from 'lodash';

class WarehouseCodesViewStore extends BaseViewStore {
	channel;
	warehouses = [];

	form = new WarehouseCodesForm({
		onSuccess: async () => {
			await this.updateChannelWarehouseCodes();
		},
	});

	constructor(rootStore, { parentViewStore }) {
		super(rootStore);
		makeObservable(this);
		this.parentViewStore = parentViewStore;
		this.channelId = parentViewStore.selectedItem ? parentViewStore.selectedItem.id : null;
		this.channelStore = new ChannelStore(rootStore);
		this.applicationStore = new ApplicationStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		if (this.parentViewStore.store_path === viewStoreName.channelListViewStore || this.parentViewStore.isEdit) {
			this.channel = await this.channelStore.getChannel(this.channelId, {
				embed: ['seller', 'convertWarehouses', 'channelType'],
			});
			this.warehouses = (await this.applicationStore.find({
				search: null,
				rpp: 30,
				page: 1,
				warehouseOnly: true,
				isOrganizationActive: true,
				sellerWarehousesOnlyOrganizationId: this.channel.sellerId,
				includeOnlySellerWarehouses: true,
			})).item;
		} else {
			this.warehouses = this.parentViewStore.warehouses;
		}
		await this.prepareData();
		this.resume();
	};

	@action.bound
	prepareData = async () => {
		if (this.parentViewStore.store_path === viewStoreName.channelListViewStore || this.parentViewStore.isEdit) {
			_.each(this.warehouses, warehouse => {
				const convertWarehouse = _.find(this.channel.convertWarehouses, convertWarehouse => {
					return convertWarehouse.warehouseId === warehouse.id;
				});
				this.form.$('warehouseCodes').add([
					{
						warehouseName: warehouse.identifier,
						name: convertWarehouse ? convertWarehouse.name : null, // Warehouse Code (ConvertWarehouse.Name in the database).
						warehouseId: warehouse.id,
						channelId: this.channel.id,
					},
				]);
			});
		} else {
			_.each(this.parentViewStore.convertWarehouses, convertWarehouse => {
				this.form.$('warehouseCodes').add([
					{
						warehouseName: convertWarehouse.warehouseName,
						name: convertWarehouse.name, // Warehouse Code (ConvertWarehouse.Name in the database).
						warehouseId: convertWarehouse.warehouseId,
					},
				]);
			});
		}
	};

	@action.bound
	updateChannelWarehouseCodes = async () => {
		this.suspend();
		try {
			const { warehouseCodes } = this.form.values();
			if (this.parentViewStore.store_path === viewStoreName.channelListViewStore || this.parentViewStore.isEdit) {
				await this.channelStore.updateChannelWarehouseCodes(
					{
						channelId: this.channel.id,
						convertWarehouses: warehouseCodes,
					},
					this.parentViewStore.store_path === 'channelListViewStore'
						? sourceOfChange.channelListUpdatelWarehouseCodes
						: sourceOfChange.channelEditUpdateWarehouseCodes
				);
				this.rootStore.notificationStore.success(['WAREHOUSECODES.SUCCESS', { channelName: this.channel.name }]);
			} else {
				this.parentViewStore.convertWarehouses = warehouseCodes;
				this.rootStore.notificationStore.success(['WAREHOUSECODES.UPDATED']);
			}
			this.parentViewStore.closeEditChannelWarehouseCodesModal();
		} catch (error) {
			this.rootStore.notificationStore.error(['WAREHOUSECODES.ERROR', { channelName: this.channel.name }]);
		}
		this.resume();
	};
}

export default WarehouseCodesViewStore;



// WEBPACK FOOTER //
// ./src/modules/channel/stores/WarehouseCodesViewStore.js